import apiService from '../../../services/api-client';
import { TransactionsRequest,TransactionsResponse } from '../interfaces/tansactions';

export const transactionsService = {
  async postTransactions(id: number, transactions: TransactionsRequest[]) {
    const { data } = await apiService().post<TransactionsResponse>(`/transactions/bulk?company_id=${id}`, transactions);
    return data;
  },
};
